import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { LolLoggerService } from './app/common/shared/lol-logger.service';
import { environment } from './environments/environment';

// Our file path
// document.write(
//  `
//  <script src="//assets.adobedtm.com/7390c55bcb09/8d96ee2bd1e9/launch-16533b0f57f5.min.js" async></script>
//  `
// );

// DataSilo path
// document.write(
//  `
//  <script src="//assets.adobedtm.com/4aea4e1020708b75ac9cc9c077bdd2a5d8656182/satelliteLib-0584160ff32580cf917e6ad1414d828a82587e21-staging.js"></script>
//  `
// );

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
];

//if (environment.production) {
enableProdMode();
//}

platformBrowserDynamic(providers).bootstrapModule(AppModule).then(() => {
  console.log('environment.production - ', environment.production);
  //if ('serviceWorker' in navigator && environment.production) {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('./ngsw-worker.js');
  }
}).catch(err => LolLoggerService.info(err));
